import { render, staticRenderFns } from "./TwoSpinNumber.vue?vue&type=template&id=a904712a&"
import script from "./TwoSpinNumber.vue?vue&type=script&lang=js&"
export * from "./TwoSpinNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports